import { patientInformationValidations } from "./patientInformationValidations";
import { authorizationToReleaseValidations } from "./authorizationToReleaseValidations";
import { informationToReleaseValidations } from "./informationToReleaseValidations";
import { deliveryMethodValidations } from "./deliveryMethodValidations";
import { purposeOfDisclosureValidations } from "./purposeOfDisclosureValidations";
import { discloseToValidations } from "./discloseToValidations";
import { formLevelValidations } from "./formLevelValidations";
import { supportingDocsValidations } from './supportingDocsValidations';
import { caseNumberValidations } from "./caseNumberValidations"
import { repContactInfoValidations } from './repContactInfoValidations';
import { additionalInfoValidations } from './additionalInfoValidations';

export const allValidations = data => {
    const {
        patientInformationSection,
        authorizationToReleaseSection,
        supportingDocsSection,
        discloseToSection,
        informationToReleaseSection,
        deliveryMethodSection,
        purposeOfDisclosureSection,
        caseNumberSection,
        repContactInfoSection,
        additionalInfoSection
    } = data.page.form.sections;

    // console.log(repContactInfoSection)

    // patientInformationValidations(patientInformationSection)

    return additionalInfoValidations(additionalInfoSection)
        .concat(patientInformationValidations(patientInformationSection))
        .concat(discloseToValidations(discloseToSection))  
        .concat(deliveryMethodValidations(deliveryMethodSection))
        .concat(purposeOfDisclosureValidations(purposeOfDisclosureSection))
        .concat(supportingDocsValidations(supportingDocsSection))
        .concat(formLevelValidations(data.page.form))
        .concat(caseNumberValidations(repContactInfoSection.fields.caseNumber))
        .concat(repContactInfoValidations(repContactInfoSection))
        .concat(additionalInfoValidations(additionalInfoSection))
        .concat(authorizationToReleaseValidations(authorizationToReleaseSection, data))
        .concat(informationToReleaseValidations(informationToReleaseSection));
};
